import React from 'react';
import moment from 'moment';
import { ReportType } from '../../shared/models/reportModels';

interface IProps {
    reportForm: any;
    columns: any;
}

const getReportTitle = (reportEnum: number) => {
    let title = 'Report';
    if (reportEnum === ReportType.ProductReport) {
        return 'Average Time Across Board Report';
    } else if (reportEnum === ReportType.ColumnReport) {
        return 'Average Time Across Board from column 1 to column 10 Report';
    } else if (reportEnum === ReportType.RepairInProgress) {
        return 'Average Repair in Progress Time Report';
    }
    return title;
}

const getDateRange = (reportForm) => {
    if (moment(reportForm.from).isValid()) {
        return `Date Range: ${moment(reportForm.from).format('DD/MM/YYYY') +
            ' to ' +
            moment(reportForm.to).format('DD/MM/YYYY')}`
    }
}

const ReportHeader = ({ reportForm, columns }: IProps) => {
    return <thead>
        <tr className="text-center">
            <th colSpan={columns.length}>{getReportTitle(reportForm.reportEnum)}</th>
        </tr>
        <tr className="text-center">
            <th colSpan={columns.length}>Date Run: {moment().format('DD/MM/YYYY hh:mma')}</th>
        </tr>
        <tr className="text-center">
            <th colSpan={columns.length}>{getDateRange(reportForm)}</th>
        </tr>
        <tr>
            {columns.map(header =>
                <th key={header.id}>{header.name}</th>
            )}
        </tr>
    </thead>
}

export default ReportHeader;